<template>
  <div class="flex float-left vertical-center">
    <vs-button
      v-bind:id="'btn-row-detail-'+rowNumber"
      size="small"
      icon-pack="feather"
      icon="icon-list"
      @click="detailRecord"
      color="primary"
      class="mr-2"
    ></vs-button>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "ActionTableAgGridComponent",
  data() {
    return {
      isConfigure:"",
      rowNumber: 0
    }
  },
  methods: {
    detailRecord(){
      this.$root.$emit("detail-from-ActionTableAgGridComponent-DeviceMonitoring",this.params.value)
    }
  },
  mounted() {
    this.rowNumber = this.params.data.no
  }
});
</script>

<style scoped>
/* .vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
} */

.vertical-center {
  margin: 0;
  position: absolute;
  top: 25px;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
</style>